import { cn } from '@/shared/ui/cn'
import { resolveStorageUrl } from '@/shared/domain'
import { env } from '@/shared/config/env'
import { SidebarTrigger } from '@/shared/ui/primitives'
import { useOrgContext } from '@/shared/ui/hooks'
import { HeaderMenu } from './header-menu'
import { PersonaSwitcher } from './persona-switcher'
import { ThemeToggle } from './theme-toggle'

type AppTopbarProps = {
  className?: string
}

export function AppTopbar({ className }: AppTopbarProps) {
  const { orgId, memberships, isImpersonating } = useOrgContext()
  const currentMembership = memberships.find((m) => m.orgId === orgId) ?? null
  const bannerUrl = currentMembership?.bannerUrl
    ? resolveStorageUrl(currentMembership.bannerUrl, env.supabaseUrl)
    : undefined

  return (
    <header
      className={cn(
        'relative flex min-h-14 items-center justify-between gap-2 py-3 pl-0 pr-2 lg:min-h-24 lg:pr-4',
        className,
      )}
    >
      {bannerUrl ? (
        <>
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(${bannerUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center 40%',
            }}
          />
          <div
            className="absolute inset-0 bg-gradient-to-b from-background/90 to-background/80 dark:from-black/85 dark:to-black/70"
          />
        </>
      ) : null}
      <div className="relative flex min-w-0 flex-1 items-center gap-2 lg:pl-6">
        <div className="flex shrink-0 pl-2 lg:hidden">
          <SidebarTrigger />
        </div>
        <div className="min-w-0 flex-1">
          {isImpersonating ? (
            <span className="truncate px-2 text-sm font-semibold text-foreground">
              {currentMembership?.orgName ?? 'Organization'}
            </span>
          ) : (
            <PersonaSwitcher />
          )}
        </div>
      </div>
      <div className="relative flex shrink-0 items-center gap-2">
        <ThemeToggle />
        <HeaderMenu />
      </div>
    </header>
  )
}
